import { render, staticRenderFns } from "./Autoinvestment.vue?vue&type=template&id=3d2ad883&scoped=true&"
import script from "./Autoinvestment.vue?vue&type=script&lang=js&"
export * from "./Autoinvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2ad883",
  null
  
)

export default component.exports